import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { ROOT_URL } from '../../api/ApiConfig';

export const createTicket = createAsyncThunk(
  'ticket/createTicket',
  async (ticketData, { getState, rejectWithValue }) => {
    try {
      const { loginToken } = getState();
      const authToken = loginToken?.response?.token;

      const response = await axios.post(
        `${ROOT_URL}/ticket/create-ticket`,
        ticketData,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const initialState = {
  loading: false,
  error: null,
  success: false,
  ticket: null,
};

const createTicketSlice = createSlice({
  name: 'createTicket',
  initialState,
  reducers: {
    resetTicketState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
      state.ticket = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createTicket.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createTicket.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.ticket = action.payload;
      })
      .addCase(createTicket.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetTicketState } = createTicketSlice.actions;
export default createTicketSlice.reducer;